module.exports = __webpack_public_path__ + "img/9788964231425.0b67f922.jpg";